module.exports = __webpack_public_path__ + "media/images/faces/face8-0f1f5bc5501cc93d381b01aaf3725573.jpg";